// extracted by mini-css-extract-plugin
export default {"root":"vu71e5","bg":"Cs68pR"};